/**
 * Form Validator - Handles client-side form validation
 */
export class FormValidator {
    constructor() {
        this.forms = new Map();
    }
    init() {
        this.setupAllForms();
    }
    setupAllForms() {
        const formsWithValidation = document.querySelectorAll('form[data-validate]');
        formsWithValidation.forEach((form) => {
            this.setupForm(form);
        });
    }
    setupForm(form, rules) {
        const formRules = rules || this.parseRulesFromDataAttributes(form);
        this.forms.set(form, formRules);
        form.addEventListener('submit', (e) => {
            if (!this.validateForm(form)) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
        // Real-time validation on blur
        const inputs = form.querySelectorAll('input, select, textarea');
        inputs.forEach((input) => {
            input.addEventListener('blur', () => {
                this.validateField(input);
            });
            input.addEventListener('input', () => {
                // Clear error on input
                this.clearFieldError(input);
            });
        });
    }
    validateForm(form) {
        const rules = this.forms.get(form);
        if (!rules)
            return true;
        let isValid = true;
        const inputs = form.querySelectorAll('input, select, textarea');
        inputs.forEach((input) => {
            if (!this.validateField(input)) {
                isValid = false;
            }
        });
        return isValid;
    }
    validateField(input) {
        const fieldRules = this.parseFieldRules(input);
        if (fieldRules.length === 0)
            return true;
        let isValid = true;
        const errors = [];
        // Required validation
        if (fieldRules.includes('required') && !input.value.trim()) {
            errors.push('Este campo es requerido');
            isValid = false;
        }
        // Email validation
        if (fieldRules.includes('email') && input.value.trim()) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(input.value)) {
                errors.push('Ingrese un email válido');
                isValid = false;
            }
        }
        // Min length validation
        const minLength = this.getRuleValue(fieldRules, 'min_length');
        if (minLength && input.value.length < parseInt(minLength)) {
            errors.push(`Mínimo ${minLength} caracteres`);
            isValid = false;
        }
        // Max length validation
        const maxLength = this.getRuleValue(fieldRules, 'max_length');
        if (maxLength && input.value.length > parseInt(maxLength)) {
            errors.push(`Máximo ${maxLength} caracteres`);
            isValid = false;
        }
        // Pattern validation
        const pattern = this.getRuleValue(fieldRules, 'pattern');
        if (pattern && input.value) {
            const regex = new RegExp(pattern);
            if (!regex.test(input.value)) {
                errors.push('Formato inválido');
                isValid = false;
            }
        }
        if (!isValid) {
            this.showFieldError(input, errors);
        }
        else {
            this.clearFieldError(input);
        }
        return isValid;
    }
    parseFieldRules(input) {
        const rulesAttr = input.getAttribute('data-rules');
        if (!rulesAttr)
            return [];
        return rulesAttr.split('|').map(rule => rule.trim());
    }
    getRuleValue(rules, ruleName) {
        const rule = rules.find(r => r.startsWith(`${ruleName}[`));
        if (!rule)
            return null;
        const match = rule.match(new RegExp(`${ruleName}\\[(.+?)\\]`));
        return match ? match[1] : null;
    }
    showFieldError(input, errors) {
        // Remove existing error
        this.clearFieldError(input);
        // Add is-invalid class
        input.classList.add('is-invalid');
        input.classList.remove('is-valid');
        // Create or update error message
        let feedback = input.parentElement?.querySelector('.invalid-feedback');
        if (!feedback) {
            feedback = document.createElement('div');
            feedback.className = 'invalid-feedback';
            input.parentElement?.appendChild(feedback);
        }
        feedback.innerHTML = errors.join('<br>');
    }
    clearFieldError(input) {
        input.classList.remove('is-invalid');
        const feedback = input.parentElement?.querySelector('.invalid-feedback');
        if (feedback) {
            feedback.remove();
        }
    }
    parseRulesFromDataAttributes(form) {
        // Default rules - can be extended
        return {};
    }
}
